module.exports = __webpack_public_path__ + "img/4Icon.0ecb2882.png";